/* PIRANGA cart sidebar: order summary, sale prices, save for later and Others Also Bought. wpbingo.js builds the lines and fires piranga:cart after every change. */
(function () {
  var variants = {}, recs = {}, entries = [];
  var cartNow = null, scrollTop = 0;
  var bookmark = '<svg width="16" height="19" viewBox="0 0 16 19" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true"><path d="M1 1h14v17l-7-5-7 5z"/></svg>';

  function money(cents) { return window.wpbingo.Currency.formatMoney(cents, window.wpbingo.strings.moneyFormat); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function saved(handle) { return typeof wishlistContains === 'function' && wishlistContains(handle); }
  function sized(url, width) { return url + (url.indexOf('?') < 0 ? '?' : '&') + 'width=' + width; }

  // compare-at prices are not in /cart.js, so they come from each product once
  function loadVariants(cart) {
    var handles = {};
    cart.items.forEach(function (i) { if (!(i.variant_id in variants)) handles[i.handle] = true; });
    var list = Object.keys(handles);
    if (!list.length) return Promise.resolve();
    return Promise.all(list.map(function (handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '.js').then(function (r) { return r.json(); }).then(function (p) {
        p.variants.forEach(function (v) { variants[v.id] = v.compare_at_price || 0; });
      }).catch(function () {});
    }));
  }

  function paintSummary(cart) {
    var box = document.querySelector('[data-pi-summary]');
    if (!box) return;
    var before = 0;
    cart.items.forEach(function (i) { before += Math.max(variants[i.variant_id] || 0, i.original_price) * i.quantity; });
    var discount = before - cart.total_price;
    var bar = document.querySelector('.shipping-bar-cart');
    var free = bar ? cart.total_price >= Number(bar.getAttribute('data-price_shipping_bar')) : false;
    box.innerHTML =
      '<div class="piranga-cart-summary__row"><span>Subtotal:</span><span>' + money(before) + '</span></div>' +
      (discount > 0 ? '<div class="piranga-cart-summary__row piranga-cart-summary__row--sale"><span>Discount:</span><span>-' + money(discount) + '</span></div>' : '') +
      '<div class="piranga-cart-summary__row' + (free ? ' piranga-cart-summary__row--free' : '') + '"><span>U.S. Standard Shipping:</span><span>' + (free ? 'Free' : 'Calculated at checkout') + '</span></div>' +
      '<p>Taxes &amp; promotional codes applied at checkout</p>';
  }

  function paintPrices(cart) {
    cart.items.forEach(function (i, index) {
      var compare = variants[i.variant_id] || 0;
      var wrap = document.querySelector('.ajaxcart__product[data-line="' + (index + 1) + '"] .ajaxcart__product-price-wrapper');
      if (!wrap || compare <= i.original_price || wrap.querySelector('del')) return;
      var price = wrap.querySelector('.ajaxcart__price');
      if (price) price.classList.add('ajaxcart__price--sale');
      var del = document.createElement('del');
      del.className = 'ajaxcart__price ajaxcart__price--regular';
      del.innerHTML = money(compare * i.quantity);
      wrap.insertBefore(del, price ? price.nextSibling : wrap.firstChild);
    });
  }

  function paintSaved() {
    document.querySelectorAll('.js-drawer [data-pi-save]').forEach(function (b) {
      b.classList.toggle('active', saved(b.getAttribute('data-pi-save')));
    });
  }

  /* ---------- Others Also Bought ---------- */
  function paintOthers(cart) {
    var box = document.querySelector('[data-pi-others]');
    if (!box || !cart.items.length) return;
    var id = cart.items[0].product_id;
    if (!recs[id]) {
      fetch('/recommendations/products.json?product_id=' + id + '&limit=10').then(function (r) { return r.json(); }).then(function (data) {
        recs[id] = data.products || [];
        if (cartNow && cartNow.items.length && cartNow.items[0].product_id === id) paintOthers(cartNow);
      }).catch(function () {});
      return;
    }
    var list = [];
    recs[id].forEach(function (p) { if (p.available) list = list.concat(colourCards(p, cart)); });
    entries = list.slice(0, 8);
    box.hidden = !entries.length;
    if (!entries.length) return;
    box.innerHTML = '<h3 class="piranga-others__title"><span>Others Also Bought</span></h3><div class="piranga-others__list">' + entries.map(function (entry, n) {
      var p = entry.p, label = p.title + (entry.colour ? ' ' + entry.colour : '');
      return '<div class="piranga-others__card" data-card="' + n + '">' +
        '<a class="piranga-others__image" href="' + esc(entry.url) + '"><img loading="lazy" src="' + esc(sized(entry.image, 360)) + '" alt="' + esc(label) + '"></a>' +
        '<button type="button" class="piranga-cart-save" data-pi-save="' + esc(p.handle) + '" aria-label="Save for later">' + bookmark + '</button>' +
        '<div class="piranga-others__foot"><span>' + money(entry.sizes[0].price) + '</span><button type="button" class="piranga-others__add" data-pi-add aria-label="Add ' + esc(label) + ' to cart">+</button></div>' +
        '</div>';
    }).join('') + '</div>';
    paintSaved();
  }

  // one card per in-stock colour with a photo of its own, as everywhere else on the site; a colour already in the cart is left out
  function colourCards(p, cart) {
    var at = -1;
    p.options.forEach(function (o, i) { if (/colou?r/i.test(o.name)) at = i; });
    var open = p.variants.filter(function (v) { return v.available; });
    var inCart = cart.items.filter(function (i) { return i.product_id === p.id; });
    if (at < 0) return inCart.length || !open.length ? [] : [{ p: p, colour: null, image: p.featured_image, url: p.url, sizes: open }];
    var cards = [];
    p.options[at].values.forEach(function (value, n) {
      var sizes = open.filter(function (v) { return v.options[at] === value; });
      var taken = inCart.some(function (i) { return i.options_with_values[at] && i.options_with_values[at].value === value; });
      if (!sizes.length || taken) return;
      var media = (p.media || []).filter(function (m) { return m.alt === value; })[0];
      var dressed = p.variants.filter(function (v) { return v.options[at] === value && v.featured_image; })[0];
      var image = media ? media.src : dressed ? dressed.featured_image.src : n === 0 ? p.featured_image : null;
      if (image) cards.push({ p: p, colour: value, image: image, url: p.url + '?variant=' + sizes[0].id, sizes: sizes });
    });
    return cards;
  }
  function sizeLabel(p, v) {
    var size = -1;
    p.options.forEach(function (o, i) { if (/size/i.test(o.name)) size = i; });
    return size < 0 ? v.title : v.options[size];
  }
  function add(id, card) {
    card.classList.add('is-adding');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function () { window.ajaxCart.load(); }).catch(function () { card.classList.remove('is-adding'); });
  }

  document.addEventListener('click', function (e) {
    var save = e.target.closest('[data-pi-save]');
    if (save) {
      e.preventDefault();
      updateWishlist(save.getAttribute('data-pi-save'));
      paintSaved();
      return;
    }
    var size = e.target.closest('[data-pi-size]');
    if (size) { e.preventDefault(); add(Number(size.getAttribute('data-pi-size')), size.closest('.piranga-others__card')); return; }
    var plus = e.target.closest('[data-pi-add]');
    if (!plus) return;
    e.preventDefault();
    var card = plus.closest('.piranga-others__card');
    var open = card.querySelector('.piranga-others__sizes');
    if (open) { open.parentNode.removeChild(open); return; }
    var entry = entries[card.getAttribute('data-card')];
    var p = entry.p, list = entry.sizes;
    if (list.length === 1) { add(list[0].id, card); return; }
    var sizes = document.createElement('div');
    sizes.className = 'piranga-others__sizes';
    sizes.innerHTML = list.map(function (v) { return '<button type="button" data-pi-size="' + v.id + '">' + esc(sizeLabel(p, v)) + '</button>'; }).join('');
    card.appendChild(sizes);
  });

  // the lines are rebuilt after every change, so the list keeps its place
  document.addEventListener('scroll', function (e) {
    if (e.target.classList && e.target.classList.contains('ajaxcart__inner')) scrollTop = e.target.scrollTop;
  }, true);

  function paint(cart) {
    cartNow = cart;
    if (!cart.items.length) { scrollTop = 0; return; }
    paintSummary(cart);
    paintSaved();
    paintOthers(cart);
    var inner = document.querySelector('.js-drawer .ajaxcart__inner');
    if (inner) inner.scrollTop = scrollTop;
    loadVariants(cart).then(function () {
      if (cartNow !== cart) return;
      paintSummary(cart);
      paintPrices(cart);
    });
  }
  document.addEventListener('piranga:cart', function (e) { paint(e.detail); });
  if (window.PIRANGA_CART) paint(window.PIRANGA_CART);
})();
